import {createSvgIcon} from '../create-svg-icon';

export const NaturePeopleIcon = createSvgIcon(
  [<circle cx="4.5" cy="9.5" r="1.5" key="0" />,<path d="M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" key="1" />,]
, 'NaturePeopleOutlined');
